<template>
  <divcard>
    <div class="d-flex justify-space-between" :class="{ 'card-part': expanded }">
      <div class="txt-head black--text">
        แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ Service Platform
      </div>

      <v-btn icon :class="{ 'rotate180': expanded }" @click="expanded = !expanded">
        <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
            :content-class="{ 'rotate180': expanded }"
        ></Iconify>
      </v-btn>
    </div>

    <div
        class="d-flex flex-column gap-12 expandable"
        :class="{ 'expanded card-part': expanded }"
    >
      <div>
        <div class="mb-1 black--text">หลักการและเหตุผล</div>
        <TextArea
            theme="3"
            :value="form.principle"
            @onChange="setFormField('principle', $event)"
        ></TextArea>
      </div>

      <div>
        <div class="mb-1 black--text">วัตถุประสงค์</div>
        <TextArea
            theme="3"
            :value="form.objective"
            @onChange="setFormField('objective', $event)"
        ></TextArea>
      </div>

      <div>
        <div class="mb-1 black--text">เป้าหมาย</div>
        <TextArea
            theme="3"
            :value="form.target"
            @onChange="setFormField('target', $event)"
        ></TextArea>
      </div>

      <div>
        <div class="mb-1 black--text">เงื่อนไข</div>
        <TextArea
            theme="3"
            :value="form.condition"
            @onChange="setFormField('condition', $event)"
        ></TextArea>
      </div>

      <div>
        <div class="txt-head black--text mb-3">การพิจารณาและลงคะแนน</div>

        <div class="mb-5">
          <div v-if="masterData.evaluate_layout">
            <router-link :to="{ name: 'ConsiderFormEdit', params: { id: masterData.evaluate_layout.id }}" target="_blank" class="theme-color-one">
              แบบฟอร์มการพิจารณาและลงคะแนน (V.{{ masterData.evaluate_layout.version }})
            </router-link>
          </div>
<!--          <AutoBox-->
<!--              theme="3"-->
<!--              :value="form.p1_title_name"-->
<!--              @onChange="setFormField('p1_title_name', $event)"-->
<!--          ></AutoBox>-->
        </div>

        <div class="d-flex justify-space-between mb-3">
          <div class="txt-head black--text">เอกสารแนบ</div>

          <Button
              theme="6"
              @onClick="addAttachment"
          >
            + เพิ่มไฟล์
          </Button>
        </div>

        <div class="theme-color-seven mb-2">*ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 10 mb/ไฟล์)</div>
        <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
          <v-flex xs7>
            <v-file-input
                v-model="files[f]"
                :id="'file' + f"
                :rules="rulesFile"
                color="#F15A29"
                style="border-radius: 30px"
                outlined
                height="36"
                placeholder=""
                prepend-icon=""
                accept="application/pdf,.doc,.docx"
                v-show="
                      checkValType(file.file_name) == 'object' ||
                      file.file_name == '' ||
                      file.file_name == null
                    "
                @change="addToAttachment(files[f])"
            ></v-file-input>
            <v-text-field
                v-show="checkValType(file.file_name) == 'string'"
                v-model="file.file_name"
                outlined
                height="36"
                color="#F15A29"
                style="border-radius: 30px"
                readonly
            ></v-text-field>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
                depressed
                dark
                rounded
                width="100"
                color="#464647"
                @click="selectFile(f)"
            >
              <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
              <span class="font-12 font-w-700">อัพโหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
                depressed
                height="35"
                width="35"
                fab
                dark
                color="#FD0C0C"
                @click="removeFile(f)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

      </div>
    </div>
  </divcard>
</template>

<script>
import TextArea from "../../../components/input/TextArea"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import { eventBus } from "../../../plugins/global-funcs"

export default {
  name: "FormServicePlatform",
  components: {
    TextArea,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    }
  },
  data () {
    return {
      expanded: false,
      form: [],
      files: [],
      attachment: [{}],
      rulesFile: [
        (value) =>
            !value ||
            value.size < 10000000 ||
            "File size should be less than 10 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    }
  },
  watch: {
    files: {
      handler (val) {
        this.form.attachments = this.attachment
        console.log('this.form.attachments@watch', this.form.attachments)
      },
      deep: true
    }
  },
  created() {
    // this.form = this.AttachmentForm
    eventBus.$on('mainProjectFormServicePlatform', () => {
      eventBus.$emit('mainProjectFormServicePlatformSend', this.form)
    })
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    addAttachment () {
      this.form.attachments = this.attachment
      console.log('addAttachment')
      this.attachment.push({})
    },
    addToAttachment(file){
      //add file in to last index of attachment
      this.attachment[this.attachment.length - 1] = file
      console.log('addToAttachment', this.attachment)
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.form.attachments = this.attachment
      console.log('removeFile', this.form.attachments)
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
  }
}
</script>

<style scoped lang="scss">

</style>